import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Card, Table } from 'antd';
import ApiService from '../../../services/ApiService';
import { MainContext } from '../../../layouts/Main/Context';
import { SIMULATION_YEARS_TABLE_COLUMNS } from './data';
import { ActionColumn } from './styles';
import { SimulationYearModal } from './SimulationYearModal';

export const SimulationYears = () => {
  const { simulationId } = useParams();
  const { setBreadcrumbItems } = useContext(MainContext);
  const [isLoading, setLoading] = useState(false);
  const [simulationYears, setSimulationYears] = useState([]);
  const [year, setYear] = useState(null);

  const fetchSimulation = async () => {
    setLoading(true);
    try {
      const data = await ApiService.retrieveSimulation(simulationId);
      if (data.success) {
        const { simulationYearArray } = data.result;
        simulationYearArray.forEach((yearItem, index) => {
          yearItem.Year = index + 1;
        });
        setSimulationYears(simulationYearArray);

        setBreadcrumbItems([
          {
            title: 'Simulations',
            path: '/main/simulations',
          },
          {
            title: data.result.simulationName,
            path: `/main/simulations/${data.result.simulationId}`,
          },
          {
            title: 'Events',
          },
        ]);

        setTimeout(() => {
          document.querySelector('.ant-table-body')?.scrollTo(0, 10000);
        }, 100);
      }
    } catch (e) {
      //
    }
    setLoading(false);
  };

  const handleAddYear = () => {
    setYear({});
  };

  const handleEditYear = yearItem => {
    setYear(yearItem);
  };

  const handleCloseYearModal = () => {
    setYear(null);
  };

  const handleYearSaved = () => {
    setYear(null);
    fetchSimulation();
  };

  useEffect(() => {
    fetchSimulation();
    // eslint-disable-next-line
  }, []);

  const simulationYearsTableColumns = [
    ...SIMULATION_YEARS_TABLE_COLUMNS,
    {
      id: 'actions',
      title: '',
      render: row => {
        if (isLoading) {
          return null;
        }
        return (
          <ActionColumn>
            <Button size="small" type="primary" ghost onClick={() => handleEditYear(row)}>
              Edit Events
            </Button>
          </ActionColumn>
        );
      },
    },
  ];

  const ActionBar = (
    <Button size="small" type="primary" onClick={handleAddYear}>
      Add Year Events
    </Button>
  );

  return (
    <>
      <Card
        size="small"
        title="Events"
        extra={ActionBar}
      >
        <p style={{ marginBottom: 16 }}>
          Configure fortuitous and disastrous event settings for each simulation year. Students start and end their own
          years — you do not need to add or end years for the class.
        </p>
        <Table
          size="small"
          pagination={false}
          scroll={{ y: 'calc(100vh - 300px)' }}
          loading={isLoading}
          columns={simulationYearsTableColumns}
          dataSource={simulationYears}
          rowKey="Year"
          bordered
          head
        />
      </Card>
      <SimulationYearModal
        simulationId={simulationId}
        years={simulationYears}
        year={year}
        onClose={handleCloseYearModal}
        onSave={handleYearSaved}
      />
    </>
  );
};
